export default {
    'it-IT': {
        ProductLabelLatestArrival: 'Nuovo',
        ProductLabelOffer: 'Promo',
        ProductPriceStartingFrom: 'da',
        FreeShipping: 'Spedizioni gratuite',
        OtherColorsAvailable: 'Altri colori disponibili',
    },
    'fr-FR': {
        ProductLabelLatestArrival: 'Nouveauté',
        ProductLabelOffer: 'Promo',
        ProductPriceStartingFrom: 'à partir de',
        FreeShipping: 'Envoi gratuit',
        OtherColorsAvailable: "Disponible en d'autres coloris",
    },
    'es-ES': {
        ProductLabelLatestArrival: 'Nuevo',
        ProductLabelOffer: 'Promo',
        ProductPriceStartingFrom: 'desde',
        FreeShipping: 'Envío gratis',
        OtherColorsAvailable: 'Más colores',
    },
    'en-GB': {
        ProductLabelLatestArrival: 'New',
        ProductLabelOffer: 'Promo',
        ProductPriceStartingFrom: 'from',
        FreeShipping: 'Free shippings',
        OtherColorsAvailable: 'Different colours available',
    },
    'en-US': {
        ProductLabelLatestArrival: 'New',
        ProductLabelOffer: 'Promo',
        ProductPriceStartingFrom: 'from',
        FreeShipping: 'Free shippings',
        OtherColorsAvailable: 'Different colors available',
    },
    'de-DE': {
        ProductLabelLatestArrival: 'Neu',
        ProductLabelOffer: 'Promo',
        ProductPriceStartingFrom: 'von',
        FreeShipping: 'Kostenlose Lieferung',
        OtherColorsAvailable: 'Andere Farben erhältlich',
    },
    'en-AU': {
        ProductLabelLatestArrival: 'New',
        ProductLabelOffer: 'Promo',
        ProductPriceStartingFrom: 'from',
        FreeShipping: 'Free shippings',
        OtherColorsAvailable: 'Different colours available',
    },
    'ko-KR': {
        ProductLabelLatestArrival: '신규',
        ProductLabelOffer: '세일',
        ProductPriceStartingFrom: '에서',
        FreeShipping: 'Free shippings',
        OtherColorsAvailable: '여러 가지 색상이 가능합니다.',
    },
};
